<div class="checkList-container">
  <div class="row checkList-header" *ngIf="trackerName">
    <div class="small-12 medium-11 columns">
      <label>Check List :</label>
    </div>
    <div class="small-12 medium-1 columns">
      <span class="checkList-close pointer float-right" (click)="closeModalDailog()">x</span>
    </div>
  </div>
  <div class="checklist-info-reveal" *ngIf="!hasSections">
    <div class="row">
      <div class="column medium-12">
        <div class="tabber">
          <div class="tab" *ngFor="let check of checklists,let i =index" (click)="switchTab(check,i)" [ngClass]="{'active-tab': tabDisplay[i].display == 'block'}">
            <span>{{check.statusName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 20px">
      <div class="column medium-12 checklist-body">
        <div class="row snooze-option statusChecklists" *ngFor="let list of statusChecklists;let i=index">
          <div class="medium-12 column checklist-info">
                        <span class="folder-success done" [style.background]="list.done ? '#14B5F0' : '#e1e1e1'">
                             <i class="material-icons" (click)="checkReferences($event, i, statusChecklists)">done</i>
                        </span>
            <span class="applicable">
                             <i class="material-icons" [style.color]="!list.applicable ? '#f1645a' : '#e1e1e1'" (click)="checkApplicable($event, i, statusChecklists)">cancel</i>
                        </span>
            <span class="check-name" [innerHTML]="list.name | linky:{stripPrefix: false, newWindow: true}"></span>
            <span class="check-mandatory" *ngIf="list.mandatory">{{'*'}}</span>
            <span class="del-checklist float-right">
                            <i class='icon ion-trash-b checklist-del-icon' (click)="deleteChecklistItems($event, i, statusChecklists)"></i>
                        </span>
            <span class="name-badge badge-tooltip check-info" *ngIf="list.info">
                            <i class="material-icons info-icon">info</i>
                            <span class="leftTooltiptext info-list">{{list.info}}</span>
                        </span>
            <span class="badge-tooltip float-right margin-top-10 checklist-diff-badge" *ngIf="list.entityType">
                            <span class='icon badge je-badge client-badge' *ngIf="list.entityType === 'Client'">C</span>
                            <span class='icon badge je-badge' *ngIf="list.entityType === 'Status'">WF</span>
                            <span class='icon badge je-badge strategy-badge' *ngIf="list.entityType === 'Strategy'">S</span>
                            <span class='icon badge je-badge task-badge' *ngIf="list.entityType === 'Task'">T</span>
                            <span class="leftTooltiptext checklist-diff-tooltip" *ngIf="list.entityType !== 'Status'">{{list.entityType}}</span>
                            <span class="leftTooltiptext checklist-diff-tooltip" *ngIf="list.entityType === 'Status'">{{'Workflow'}}</span>
                        </span>
            <div *ngIf="list.description.length > 0">
                            <span class="check-name" style="font-size: 12px"
                                  [innerHTML]="list.description | linky:{stripPrefix: false, newWindow: true}">
                            </span>
            </div>
            <div class="check-lists" *ngFor="let ref of list.references;let i1=index">
              <div class="medium-12 column check-banks">
                                <span class="bank-check">
                                    <input class="bank-checkbox" type="checkbox" [(ngModel)]="ref.isDone" (change)="checkBanks(list,i)">
                                </span>
                <span class="entity">{{ref.entity}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="checklist-info-reveal" *ngIf="hasSections">
    <div class="row">
      <div class="column medium-12">
        <div class="tabber">
          <div class="tab" *ngFor="let check of taxPlanChecklists,let i =index" (click)="switchTabForTaxPLan(check,i)" [ngClass]="{'active-tab': tabDisplay[i].display == 'block'}">
            <span>{{check.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 20px">
      <div class="column medium-12 checklist-body">
        <div class="row snooze-option statusChecklists" *ngFor="let list of statusSections;let i=index">

          <div class="medium-12 column checklist-info">
                            <span class="folder-success done" [style.background]="list.done ? '#14B5F0' : '#e1e1e1'">
                                 <i class="material-icons" (click)="checkReferences($event, i, statusSections)">done</i>
                            </span>
            <span class="applicable">
                                 <i class="material-icons" [style.color]="!list.applicable ? '#f1645a' : '#e1e1e1'" (click)="checkApplicable($event, i, statusSections)">cancel</i>
                            </span>
            <span class="check-name" [innerHTML]="list.name | linky:{stripPrefix: false, newWindow: true}"></span>
            <span class="check-mandatory" *ngIf="list.mandatory">{{'*'}}</span>
            <span class="del-checklist float-right">
                                <i class='icon ion-trash-b checklist-del-icon' (click)="deleteChecklistItems($event, i, statusSections)"></i>
                            </span>
            <span class="badge-tooltip check-info" style="position: relative; top: 8px;" *ngIf="selectedStatusName == 'Setup' || selectedStatusName == 'Recurring'">
                                <i class='icon ion-android-person' (click)="openTodoPage(list)"></i>
                                <span class="leftTooltiptext info-list">Add as client to-do</span>
                            </span>
            <span class="name-badge badge-tooltip check-info" *ngIf="list.info">
                                <i class="material-icons info-icon">info</i>
                                <span class="leftTooltiptext info-list">{{list.info}}</span>
                            </span>
            <div *ngIf="list.description.length > 0">
                                <span class="check-name" style="font-size: 12px"
                                      [innerHTML]="list.description | linky:{stripPrefix: false, newWindow: true}">
                                </span>
            </div>
            <div class="check-lists" *ngFor="let ref of list.references;let i1=index">
              <div class="medium-12 column check-banks">
                                    <span class="bank-check">
                                        <input class="bank-checkbox" type="checkbox" [(ngModel)]="ref.isDone" (change)="checkBanks(list,i)">
                                    </span>
                <span class="entity">{{ref.entity}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="medium-10 columns">
            <span>
            <span class="pointer" style="position: relative;top: 20px" (click)="openCheckList()">
                <i class="icon ion-ios-plus-outline"></i>
            </span>
            <span class="pointer" style="position: relative;top: 17px" (click)="openCheckList()">Checklist</span>
            </span>
    </div>
    <div class="medium-2 columns text-right checkList-save">
      <button class="button small" (click)="saveCheckList()">SAVE</button>
    </div>
  </div>
</div>

<div *ngIf="reveal['addChecklist']">
  <div [ngClass]="{'tpiq-reveal': reveal['addChecklist']}" class="reveal-overlay" (click)="hideReveal('addChecklist')"></div>
  <div [ngClass]="{'tpiq-reveal': reveal['addChecklist']}" class="reveal tax-strategy-reveal" style="width: 45%;padding: 0;border: 1px;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Add New Checklist !!</span>
      <span (click)="hideReveal('addChecklist')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div class="row label-top">
        <div class="small-4 medium-2 columns">
          <label class="label-name label-top">Status</label>
        </div>
        <div class="small-6 medium-6 columns">
          <label class="gray-color">
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="preferredStatuses" [setPlaceHolder]="'Status'" [setSearchKey]="'name'" [setValueKey]="'id'" [setDefaultValue]="trackerStatus"
                                      (onValueSelect)="onCheckListStatusSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>

        <div class="small-4 medium-12 columns" style="margin-left: 6rem;margin-top: 10px">
          <label class="gray-color">
            <app-tpiq-input-search [setData]="" [setPlaceHolder]="'Check List'" [setSearchKey]="''" [setValueKey]="''" [setDefaultValue]=""
                                   [showDescriptionFlag]= "true" [setAddNewFlag]="true" (onNewItemAddition)="onAddChecklist($event)"></app-tpiq-input-search>
          </label>
        </div>
      </div>

      <div class="row workflow-checklist workflow-status">
        <div class="small-12 medium-12 columns selectedValues">
          <ul class="sortableChecklist drilldown-column status-column sortable-status" style="width: 100%;margin-right: 6rem">
            <li class="status-close" [ngClass]="value.editingName ? 'input-status-edit' : 'ui-state-default' " *ngFor="let value of selectedChecklists;let i = index" style="clear: both">
                        <span class="pointer checklist-checkbox">
                            <input class="check-icon" type="checkbox" [(ngModel)]="value.isMandatory" [ngModelOptions]="{standalone: true}">
                        </span>
              <span class="fix-color" [hidden]="value.editingName">{{value.name}}</span>
              <span class="pointer checklist-remove" (click)="removeCheckListValue(i)">
                            <i class="icon ion-close-round workflow-font"></i>
                        </span>
              <textarea rows="2" [hidden]="value.description.length === 0" style="color: #666666;font-size: 14px;margin: 0" placeholder="Description..." [(ngModel)]="value.description" [ngModelOptions]="{standalone: true}" ></textarea>
            </li>
          </ul>
        </div>
      </div>

      <div class="row footer">
        <div class="small-12 medium-12 columns btn-row">
          <div class="text-right btn-wrapper" style="padding-right: 10px">
            <button class="button small" (click)="onNewChecklistSubmit()">APPLY</button>
            <button class="button small" style="background: #f1645a;" (click)="closeDailog('addChecklist')">CANCEL</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
